export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <a href="#hero" className="inline-block mb-4 no-underline">
                <span className="text-2xl font-bold font-heading text-primary-400 whitespace-nowrap">51影视</span>
              </a>
              <p className="text-sm leading-relaxed text-foreground-400">
                51影视致力于提供免费影视在线观看服务，高清不卡顿、不缓冲流畅体验，海量视频免费看。涵盖电影、电视剧、综艺、动漫等全品类内容，每日更新，随时随地畅享观影乐趣。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">快捷导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '热门专题', href: '#index' },
                  { label: '热播排行', href: '#ranking' },
                  { label: '精选推荐', href: '#cards' },
                  { label: '精彩片段', href: '#media' },
                  { label: '最新动态', href: '#updates' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">服务支持</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '常见问题', href: '#faq' },
                  { label: '联系我们', href: '#contact' },
                  { label: '平台优势', href: '#features' },
                  { label: '移动观影', href: '#app' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 51影视网. 本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline cursor-pointer">回到顶部</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}